import { cva, cx } from '@vizit/theme';
import * as React from 'react';
import { Separator as AriaSeparator, type SeparatorProps as AriaSeparatorProps } from 'react-aria-components';

interface SeparatorProps extends AriaSeparatorProps {}

const classes = cva({
  base: 'shrink-0 bg-quaternary',
  variants: {
    orientation: {
      horizontal: 'border-none h-px w-full',
      vertical: 'h-full w-px',
    },
  },
});

/**
 * The Separator component is used to separate content.
 *
 * @param props - The props for the Separator component.
 * @example
 * <Separator />
 */
function Separator(props: SeparatorProps, ref: React.ForwardedRef<HTMLElement>) {
  const { className, orientation = 'horizontal', ...other } = props;

  return (
    <AriaSeparator ref={ref} className={cx(classes({ orientation }), className)} orientation={orientation} {...other} />
  );
}

const _Separator = React.forwardRef<HTMLElement, SeparatorProps>(Separator);

export type { SeparatorProps };
export { _Separator as Separator };
